import script from "./SidebarPrograms.vue?vue&type=script&lang=ts&setup=true"
export * from "./SidebarPrograms.vue?vue&type=script&lang=ts&setup=true"

import "./SidebarPrograms.vue?vue&type=style&index=0&id=2228e4c2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2228e4c2"]])

export default __exports__